import { ROLE_TYPES } from 'utils/permissions';

export const EXCHANGE_RATES_PERMISSION = {
  exchangeRates: [ROLE_TYPES.ceo, ROLE_TYPES.finance_specialist],
};
